export default __webpack_public_path__ + "df2124ce70fb8121440e318a18043cce.gif";